<template>
  <div class="staff-credits-table">
    <data-table
      :config="datatableConfig"
      :data="rows"
      :refreshButton="{ show: true }"
      @edit-click="handleEditClick"
      @refresh="emit('refresh')"
    />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { eventBus } from '../../../eventBus'
import type { AiCredits_LedgerRow } from '../../../contracts/AiCredits_LedgerRow'
import { formatCredits } from '../../assistant/formatCredits'

const { t } = useI18n()

interface Props {
  rows: AiCredits_LedgerRow[]
}

const props = defineProps<Props>()

const emit = defineEmits<{
  refresh: []
}>()

function handleEditClick(id: unknown): void {
  const row = props.rows.find((r) => r.id === Number(id))
  if (!row) return
  eventBus.emit('modal.credit-transaction.open', row)
}

const tableColumns = computed(() => [
  {
    data: 'id',
    title: t('ID'),
    renderType: 'clickable_id',
  },
  {
    data: 'franchise_name',
    title: t('Franquia'),
  },
  {
    data: 'entry_type',
    title: t('Tipo'),
  },
  {
    data: 'signed_micro',
    title: t('Créditos'),
    cellRenderer: ({ value }: { value: unknown }) => `${formatCredits(value as number)} cr`,
  },
  {
    data: 'balance_after_micro',
    title: t('Saldo após'),
    cellRenderer: ({ value }: { value: unknown }) => `${formatCredits(value as number)} cr`,
  },
  {
    data: 'request_id',
    title: t('Request ID'),
  },
  {
    data: 'created_at',
    title: t('Data'),
    renderType: 'datetime',
  },
])

const datatableConfig = computed(() => ({
  tableId: 'staffCreditsLedgerTable',
  columns: tableColumns.value,
  pagination: true,
  pageLength: 25,
}))
</script>
